<template>
  <div>
    <!-- SUPPORTING DOCUMENTS MODAL -->
    <div class="text-center">
      <v-dialog v-model="supporting_documents" max-width="750px">
        <v-card>
          <div
            style="border-top: 5px solid rgb(86, 182, 229);"
          >
            <v-card-title>
              <v-toolbar color="transparent" flat class="pt-2">
                <v-col cols="12" sm="6" class="mt-5">
                  <v-icon
                    style="float: left; background-color: rgb(86, 182, 229); color: #fff;"
                    class="float-left mr-2"
                    @click="closeSupportingDocumentsDialog"
                    >mdi-chevron-left</v-icon
                  >
                  <v-toolbar-title
                    class="text-uppercase font-weight-bold text--darken-1 justify-center"
                    style="color: rgb(86, 182, 229);"
                  >
                    Supporting Documents
                  </v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                </v-col>
              </v-toolbar>
            </v-card-title>
            <v-card-text>
              <div style="height: 92%; overflow: auto">
                <v-card class="grey lighten-2" style="padding-bottom: 20px" v-if="files.length > 0">
                  <div
                    style="overflow: auto"  
                  >
                    <div v-if="store.getLoading">
                      <v-progress-linear
                        color="rgb(86, 182, 229)"
                        indeterminate
                        rounded
                        height="6"
                      ></v-progress-linear>
                    </div>

                    <div style="width: 100%;">
                      <v-table 
                        v-if="files && files.length > 0"
                        height="250px"
                        fixed-header
                      >
                        <thead>
                          <tr>
                            <th style="background-color: rgb(86, 182, 229); font-weight: bolder;" class="text-left text-white">No.</th>
                            <th style="background-color: rgb(86, 182, 229); font-weight: bolder;" class="text-left text-white"></th>
                            <th style="background-color: rgb(86, 182, 229); font-weight: bolder;" class="text-left text-white">Name</th>
                            <th style="background-color: rgb(86, 182, 229); font-weight: bolder;" class="text-left text-white">Size</th>
                            <th style="background-color: rgb(86, 182, 229); font-weight: bolder;" class="text-left text-white">Created On</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in files" 
                            :key="index"
                            class="table-striped"
                          >
                            <td style="overflow: hidden; text-overflow: ellipsis; padding-top: 20px; padding-bottom: 20px;">
                              {{ index + 1 + "." }}
                            </td>
                            <td style="overflow: hidden; text-overflow: ellipsis;">
                              <span class="input-group-addon">
                                <v-progress-circular
                                  v-if="loading[item.itemId]"
                                  indeterminate
                                  color="rgb(86, 182, 229)"
                                ></v-progress-circular> 
                                <v-icon
                                  v-else
                                  :color="fileIds.includes(item.itemId) ? 'rgb(227, 58, 58)' : 'rgb(86, 182, 229)'"
                                  class="mr-2"
                                  size="large"
                                  :icon="globalMethods.getDocumentIcon(item.itemExtension)"
                                />
                              </span>
                            </td>
                            <td style="overflow: hidden; text-overflow: ellipsis;">
                              <file-options
                                :file="item"
                                :file_color="'rgb(86, 182, 229)'"
                                v-if="item.itemExtension == 'pdf'"
                                :briefcase-files="fileIds"
                                :select_type="true"
                                :pdf_type="2"
                                @open_pdf="getDocument(item)"
                                @briefcase_pdf="briefcaseDocument(item)"
                              ></file-options>
                              <span 
                                v-else
                                @click="getDocument(item)"
                                class="name"
                              >
                                {{ item.itemName }}
                              </span>
                            </td>
                            <td style="overflow: hidden; text-overflow: ellipsis;">
                              {{ getPrettyBytes(item.itemSize) }}
                            </td>
                            <td style="overflow: hidden; text-overflow: ellipsis;">
                              <span v-if="item.itemCreatedOn">
                                {{ formatDate(item.itemCreatedOn) }}
                              </span>
                              <span v-else>
                                --
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </v-table>
                      <v-table v-else>
                        <thead>
                          <tr>
                            <th class="text-left text-white" style="background-color: rgb(86, 182, 229); font-weight: bolder;">No.</th>
                            <th class="text-left text-white" style="background-color: rgb(86, 182, 229); font-weight: bolder;"></th>
                            <th class="text-left text-white" style="background-color: rgb(86, 182, 229); font-weight: bolder;">Name</th>
                            <th class="text-left text-white" style="background-color: rgb(86, 182, 229); font-weight: bolder;">Size</th>
                            <th class="text-left text-white" style="background-color: rgb(86, 182, 229); font-weight: bolder;">Created On</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td 
                              colspan="6"
                              class="text-center"
                            >
                              <span>
                                No Supporting Documents Found
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </v-table>
                    </div>
                  </div>
                </v-card>
                <v-card class="grey lighten-2" style="padding-bottom: 20px" v-else>
                  <v-card-text
                    class="ml-1"
                    style="
                      color: rgb(72, 61, 139);
                      font-size: 19px;
                      font-weight: bold;
                    "
                  >
                    No Supporting Documents Found
                  </v-card-text>
                </v-card>
              </div>
            </v-card-text>
            <v-card-actions class="grey" @click="closeSupportingDocumentsDialog">
              <v-btn 
                block
                color="rgb(86, 182, 229)"
              >
                Close
              </v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
var moment = require("moment");
import prettyBytes from 'pretty-bytes';
import { useAuthStore } from "../../stores/auth";
import { useIndexStore } from "../../stores/index";
import { useAlertStore } from "../../stores/alert";
import GlobalMethods from '../repository/GlobalMethods';
import FileOptions from '../Cards/FileOptions.vue';

export default {
  name: "SupportingDocuments",
  props: {
    description: {
      type: String,
      default: "",
    },
    files: {
      type: Array,
      default: () => [],
    },
    fileIds: {
      type: Array,
      default: () => [],
    },
  },

  components: { 
    FileOptions 
  },

  data: () => ({
    globalMethods: GlobalMethods,
    valid: false,
    dialog: false,
    interestDisclosed: "",
    interestConflict: "",
    hasConflict: false,
    confirm: false,
    comments: "",
    conditions: "",
    password: "",
    rules: {
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => (v && v.length >= 3) || "Min 3 characters",
      ],
      selectRules: [(v) => !!v || "Select is required"],
      textRules: [
        v => !!v || 'Field is required',
        v => (v && v.length >= 3) || 'Min 3 characters',
      ],
      characterRules: [
        v => (v && v.length >= 3) || 'Min 3 characters',
      ],
    },
    token: localStorage.getItem("token") ? JSON.stringify(localStorage.getItem("token")).slice(1, -1) : "",
    auth: useAuthStore(),
    store: useIndexStore(),
    alert: useAlertStore(),
    loading: {},
  }),

  computed: {
    user() {
      return this.auth.getLoggedInUser;
    },

    supporting_documents: {
      get: function () {
        return this.store.getSupportingDocuments;
      },
      set: function (value) {
        this.store.setSupportingDocuments(value);
      }
    },
  },
  
  methods: {
    formatDate(date) {
      return moment.unix(date).format("DD MMM YYYY");
    },

    getPrettyBytes(value) {
      return prettyBytes(parseInt(value));
    },

    validate() {
      return this.$refs.form.validate();
    },

    resetForm() {
      return this.$refs.form.reset();
    },

    resetValidation() {
      return this.$refs.form.resetValidation();
    },

    closeSupportingDocumentsDialog() {
      this.store.setSupportingDocuments(false);
      document.querySelector('html').classList.remove('v-overlay-scroll-blocked');
    },

    getDocument(file) {
      this.$emit('open_supporting_document', file);
    },

    briefcaseDocument(item) {
      this.loading[item.itemId] = true;
      this.globalMethods.downloadEbrDocument(item.itemUrl).then(async (response) => {
        if (response.status == 200) {
          let fileType = response.headers['content-type'];
          let fileData = new Blob([response.data], { type: fileType });
          let blob = window.URL.createObjectURL(fileData);
          this.getDocument(item, blob);
          this.loading[item.itemId] = false;
        } else {
          this.loading[item.itemId] = false;
          console.log("Response: ", response);
        }
      }).catch((e) => {
        this.loading[item.itemId] = false;
        console.log("Error: ", e);
      });
    },
  },
};
</script>

<style scoped>
.name {
  cursor: pointer !important;
}

.name:hover {
  color: rgb(86, 182, 229) !important;
}

/* Zebra striping for table rows */
tbody tr:nth-child(even) {
  background-color: #f5f5f5 !important;
}

tbody tr:nth-child(odd) {
  background-color: rgb(200, 228, 247) !important;
}
</style>
